import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { viewStaffApi } from "../../api/staffService";
import { getErrorMessage } from "../../utils/errorHandler";
import Button from "../../utils/Buttons";
export default function ViewStaff() {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const staffId = params?.staffId || location?.state?.staffId;
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!staffId) {
      setLoading(false);
      return;
    }
    const fetchStaff = async () => {
      try {
        setLoading(true);
        const response = await viewStaffApi(staffId);
        setStaff(response?.data || response);
      } catch (err) {
        setError(getErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [staffId]);
  if (loading) {
    return (
      <div className="container mt-4">
        <div className="card">
          <div className="card-body text-center py-4">Loading...</div>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }
  if (!staff) {
    return (
      <div className="container mt-4">
        <div className="card">
          <div className="card-body text-center py-4">Staff not found</div>
        </div>
      </div>
    );
  }
  const clinics =
    typeof staff?.clinics === "string"
      ? staff.clinics
      : Array.isArray(staff?.clinics)
        ? staff.clinics.map((c) => c?._id || c).join(", ")
        : staff?.clinics?._id || "";
  return (
    <div className="container mt-4">
      <div className="card p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">View Staff</h5>
          <Button
            text="Back to Staff"
            className="btn btn-sm btn-outline-dark"
            onClick={() => navigate("/staff")}
          />
        </div>
        <div className="row g-3">
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Full Name : </span>
            {staff?.fullName || "N/A"}
          </div>
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Email : </span>
            {staff?.email || "N/A"}
          </div>
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Mobile : </span>
            {staff?.mobileCountryCode || "N/A"}
          </div>
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Role : </span>
            {staff?.role || "N/A"}
          </div>
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Gender : </span>
            {staff?.gender || "N/A"}
          </div>
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Status : </span>
            {staff?.status || "N/A"}
          </div>
          <div className="col-md-4 mb-2">
            <span className="fw-bold">Clinic : </span>
            {clinics || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}
